<!--
  Chooses which Pinterest board a pin files on.

  The default is the board for the campaign's own subject — its audience, or its product when it doesn't name
  one — created on demand at send time. That's what makes pins findable, so overriding it should be a deliberate
  act rather than the normal path.
-->
<template>
  <v-dialog
    v-model="dialog"
    max-width="520"
  >
    <v-card>
      <v-card-title class="text-h6">
        Pinterest board
      </v-card-title>

      <v-card-text>
        <v-radio-group
          v-model="useSubjectBoard"
          hide-details
          class="mt-0"
        >
          <v-radio :value="true">
            <template #label>
              <div>
                <div>{{ subjectBoardName }}</div>
                <div class="text-caption grey--text">
                  {{ subjectBoardHint }}
                </div>
              </div>
            </template>
          </v-radio>
          <v-radio :value="false">
            <template #label>
              <div>
                <div>A different board</div>
                <div class="text-caption grey--text">
                  Files this one pin elsewhere. Other pins for this audience are unaffected.
                </div>
              </div>
            </template>
          </v-radio>
        </v-radio-group>

        <v-select
          v-if="!useSubjectBoard"
          v-model="boardId"
          :items="boards"
          item-text="name"
          item-value="id"
          label="Board"
          outlined
          dense
          class="mt-4"
          hide-details
        />
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          @click="dialog = false"
        >
          Cancel
        </v-btn>
        <v-btn
          color="primary"
          :loading="saving"
          :disabled="!useSubjectBoard && !boardId"
          @click="save"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'CampaignBoardDialog',
  data() {
    return {
      dialog: false,
      saving: false,
      itemId: 0,
      useSubjectBoard: true,
      boardId: null,
      boards: [],
      subjectBoard: null
    };
  },
  computed: {
    subjectBoardName() {
      if (!this.subjectBoard) return 'This campaign\'s own board';
      if (this.subjectBoard.isDefault) return 'Default board';
      return this.subjectBoard.name;
    },
    subjectBoardHint() {
      if (!this.subjectBoard) return '';
      if (this.subjectBoard.isDefault) {
        return 'We can\'t work out a subject for this campaign, so its pins go to the default board.';
      }
      return this.subjectBoard.exists
        ? 'The board we keep for this campaign\'s subject.'
        : 'Not created yet — it will be created, and named, when the first pin posts.';
    }
  },
  methods: {
    // Public — the parent opens this through $refs, passing the payload it already loaded.
    open(itemId, pinterest) {
      this.itemId = itemId;
      this.boards = (pinterest.boards || []).map((b) => ({ id: b.id, name: b.name }));
      this.subjectBoard = pinterest.subjectBoard || null;
      this.boardId = pinterest.overrideBoardId || null;
      this.useSubjectBoard = !pinterest.overrideBoardId;
      this.dialog = true;
    },
    save() {
      this.saving = true;
      // An empty board id clears the override on the server.
      const boardId = this.useSubjectBoard ? '' : this.boardId;
      this.$store
        .dispatch('campaigns/setPinterestBoard', { itemId: this.itemId, boardId })
        .then(() => {
          this.dialog = false;
          this.$root.$snackbarSuccess('Board updated');
          this.$emit('saved');
        })
        .catch((error) => this.logError(error))
        .finally(() => {
          this.saving = false;
        });
    }
  }
};
</script>
